/**
 * @type {{Number}} Время, через которое будет скрыта плашка с уведомлением
 */
export const NOTIFICATION_TIMEOUT_HIDE_INFO_MESSAGE = 5000;
